<div class="bet-slip-check-row">
  <input placeholder="{{ 'enter_booking_code' | translate }}" class="slipcheck-input" type="number" [(ngModel)]="this._UiHelper.bookingCode" />
  <ng-container *ngIf="this._UiHelper.bookingCode && this._UiHelper.bookingCode.toString().length > 0; else disableTemplate">
    <div class="search-button-container" (click)="onSearchClick()">
      <div class="btn-text">{{ 'Confirm' | translate }}</div>
    </div>
  </ng-container>
  <ng-template #disableTemplate>
    <div class="search-button-container disabled">
      <div class="btn-text">{{ 'Confirm' | translate }}</div>
    </div>
  </ng-template>
</div>
